import React from 'react';

import RecordsScreen from '/component/layout/RecordsScreen';
import {COACH_REPORT} from '/enum/popover.enum';
import {REPORT_CARD_CONTENT_EARNED_QSB} from '/enum/reportCard.enum';
import {withTranslation} from '/provider/TranslationProvider';
import {withHOC} from '/util/hoc.util';

import {ReportProps} from '../Report.types';
import withRecordPopover from '../withRecordPopover';

import {EarnedQsbReportContent} from './EarnedQsbReportContent';
import reportPayload from './reportPayload';

export const EarnedQsbReport = ({
  loadingData = {total: 0},
  tt = (key: string, defaultValue?: string) => defaultValue || '',
  showRecordPopover = () => {},
}: ReportProps) => {
  return (
    <RecordsScreen
      {...reportPayload}
      // @ts-expect-error TS(2322): Type '{ title: any; description: any; contentProps... Remove this comment to see the full error message
      title={tt('title', 'Earned Quick Start Bonus')}
      description={tt(
        'description',
        'New Coaches who have earned a Quick Start Bonus in their first 60 days.',
      )}
      contentProps={{loadingData, showRecordPopover}}
      contentComponent={EarnedQsbReportContent}
    />
  );
};

export default withHOC(
  withTranslation('report.EarnedQsbReport'),
  withRecordPopover({
    reportPayload,
    popoverName: COACH_REPORT,
    popoverContentName: REPORT_CARD_CONTENT_EARNED_QSB,
    popoverContentProps: {},
  }),
)(EarnedQsbReport);
